var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250.23 260.3",
    style: {
      enableBackground: "new 0 0 250.23 260.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#231F20;}\n\t.st2{fill:url(#SVGID_00000026121898858118435790000004265199936382894239_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_00000082358003886066020060000018252549845216792455_);}\n\t.st5{fill:url(#SVGID_00000026843498488589421300000017713983295051909294_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.8969,
    y1: 130.1475,
    x2: 224.3293,
    y2: 130.1475
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#62BDC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6694EC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.11,15.58L25.9,72.86v114.57l99.22,57.28l99.22-57.28V72.86L125.11,15.58z M41.38,81.8l83.73-48.34 l75.98,43.87l-25.52,14.74l-50.47-29.12L61.33,99.75v2.51v6.19v49.58l-19.95,11.51V81.8z M125.11,179.13l-5.27-2.85l-1.52-0.73 l-41.5-23.96V111.2l31.43,18.16l16.87,9.83l42.73-24.77v40.4l-34.99,20.19v-0.11L125.11,179.13z M90.12,101.01l34.98-20.19 l34.98,20.19l-34.99,20.2L90.12,101.01z M208.85,178.49l-83.73,48.34l-75.99-43.88l25.53-14.73l50.46,29.13l58.22-33.59v-58.29 l25.52-14.73V178.49z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGradient);
export default __webpack_public_path__ + "static/media/logo-gradient.572cf57487182f17fe0c8af8325de8fa.svg";
export { ForwardRef as ReactComponent };